import o from"styled-components";import{theme as i}from"../../../theme.js";const e=o.div`
  padding: ${i.spacing*4}px;
  border-radius: ${i.radius}px;
  box-shadow: ${i.boxShadow};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${i.spacing*4}px;
  .content {
    display: flex;
    flex-direction: column;
    gap: ${i.spacing*2}px;
  }
`,r=o.div`
  > img {
    aspect-ratio: 16/9;
    object-fit: cover;
    width: 100%;
    border-radius: ${i.radius}px;
  }
`,t=o.h3`
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  color: ${i.colors.gray[900]};
  margin: 0;
`,a=o.p`
  font-size: 14px;
  color: ${i.colors.gray[700]};
  line-height: 21px;
  margin: 0;
`,n=o.p`
  font-size: 12px;
  font-style: italic;
  color: ${i.colors.gray[400]};
  margin: 0;
`,p=o.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${i.spacing*2}px;
`;export{n as Caption,e as Container,a as Description,r as PictureContainer,p as TagsContainer,t as Title};
